"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = NotAvailableOffers;
var _r10SourceLibrary = require("r10-source-library");
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _useConfig2 = _interopRequireDefault(require("../hooks/useConfig"));
var _useTranslation = _interopRequireDefault(require("../hooks/useTranslation"));
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var Wrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n"])));
function NotAvailableOffers() {
  var t = (0, _useTranslation.default)();
  var _useConfig = (0, _useConfig2.default)('widgetCustomization'),
    _useConfig$noOffersIc = _useConfig.noOffersIconName,
    noOffersIconName = _useConfig$noOffersIc === void 0 ? 'info-circle' : _useConfig$noOffersIc,
    _useConfig$noOffersIc2 = _useConfig.noOffersIconGroup,
    noOffersIconGroup = _useConfig$noOffersIc2 === void 0 ? 'midLight' : _useConfig$noOffersIc2,
    _useConfig$noOffersIc3 = _useConfig.noOffersIconSize,
    noOffersIconSize = _useConfig$noOffersIc3 === void 0 ? 2 : _useConfig$noOffersIc3;
  return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 8,
      bottom: 8
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Container, {
    elevation: true,
    paddingLevel: 6
  }, /*#__PURE__*/_react.default.createElement(Wrapper, {
    "data-testid": "not-available-offers-card"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      bottom: 4
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Icon, {
    name: noOffersIconName,
    group: noOffersIconGroup,
    size: noOffersIconSize
  })), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    size: 2,
    weight: 2,
    justify: "center"
  }, t('no_offers')))));
}